type WaitlistListingLike =
  | {
      isWaitlisted?: boolean | null;
      userOnWaitlist?: boolean | null;
      waitlisted?: boolean | null;
    }
  | null
  | undefined;

const asWaitlistListing = (listing: unknown): WaitlistListingLike =>
  listing as WaitlistListingLike;

export const isWaitlistedListing = (listing: unknown): boolean => {
  const waitlistListing = asWaitlistListing(listing);
  return Boolean(waitlistListing?.waitlisted || waitlistListing?.isWaitlisted);
};

export const isUserOnWaitlist = (listing: unknown): boolean => {
  const waitlistListing = asWaitlistListing(listing);
  return Boolean(waitlistListing?.userOnWaitlist);
};
